import { connect } from "react-redux";

import { RootState } from "src/ipm-shared/store/model/reducers";

import * as selectors from "src/bepaid/store/model/Fetch/selectors";

import Component from "./View";

const mapStateToProps = (state: RootState) => ({
  isPersonalAccount: selectors.getIsPersonalAccount(state),
  isBusinessAccount: selectors.getIsBusinessAccount(state)
});

export default connect(mapStateToProps, null)(Component);
